<template>
    <div class="prompt" :class="`txt-${options.type}`"><span class="xdicon xdicon-error" v-if="options.type == 'error'"></span>{{options.msg}}</div>
</template>

<script>
export default {
    props: {
        options: {
            type: Object,
            default: () => {
                return {
                    type: '',
                    msg: ''
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .prompt {
        display: flex;
        align-items: center;
        color: $reward;
        span {
            margin-right: 5px;
        }
    }
    .txt-default {
        color: $black_txt;
    }
    .txt-error {
        color: $reward;
    }
    .txt-success {
        color: $green;
    }
</style>